import React from "react";

import HighlightIcon from "@material-ui/icons/Highlight";

function Header() {
  return (
    <header>
      {/* <HighlightIcon /> */}
      <h1>Notes_Keeper App</h1>
    </header>
  );
}

export default Header;
